import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon";
import { tv } from "@ui/lib/tv";

const marketplaceSearchField = tv({
  slots: {
    root: "flex min-w-0 flex-1 items-center gap-2",
    input: [
      "min-w-px flex-1 border-0 bg-transparent text-xl font-semibold leading-7 text-neutral-900 outline-none",
      "placeholder:text-neutral-400",
    ],
  },
});

export interface MarketplaceSearchFieldProps {
  onChange: (value: string) => void;
  value: string;
  /** Extends the root row — e.g. height/padding when not wrapped in `MarketplaceSearchBar`. */
  className?: string;
}

/** The bare search icon + text input. Standalone it carries no pill chrome, so it slots
 *  straight into the `SearchBar` (PillGroup) bar as the flexible left region — the
 *  marketplace equivalent of the SearchBar's Where/When sections. Wrap it in
 *  `MarketplaceSearchBar` for the rounded pill used by the mobile search overlay. */
export function MarketplaceSearchField({ onChange, value, className }: MarketplaceSearchFieldProps) {
  const styles = marketplaceSearchField();

  return (
    <div className={styles.root({ className })}>
      <Icon name="search" size="32" type="sticker" />
      <input
        aria-label={t("components.views.shared.marketplace_search.search_placeholder")}
        className={styles.input()}
        onChange={(event) => onChange(event.target.value)}
        placeholder={t("components.views.shared.marketplace_search.search_placeholder")}
        type="search"
        value={value}
      />
    </div>
  );
}
